import React, { useRef, useState, useEffect } from "react";
import Layout from "../component/Layout/Layout";
import { useNewHomeAPI } from "../hooks/useAllCategoryData";
import { Link } from "react-router-dom";

const StoreGalleryDubai = () => {
  /* const images = [
    '/images/catimg/Cocktail.jpg',
    '/images/catimg/Festive-Wear.jpg',
    '/images/catimg/Gowns.jpg',
    '/images/catimg/Indo-Westerns.jpg',
    '/images/catimg/Lehengas.jpg',
    '/images/catimg/Pre-Stitched-Sarees.jpg',
    '/images/catimg/Sangeet-Mehendi.jpg',
    '/images/catimg/Shararas-Gararas.jpg',
    '/images/catimg/Western-Wear.jpg'
  ]; */

  /* const images = [
    {
      mobile: "01.jpg",
      desktop: "01.jpg",
    },
    {
      mobile: "02.jpg",
      desktop: "02.jpg",
    },
    {
      mobile: "03.jpg",
      desktop: "03.jpg",
    },
    {
      mobile: "04.jpg",
      desktop: "04.jpg",
    },
    {
      mobile: "05.jpg",
      desktop: "05.jpg",
    },
    {
      mobile: "06.jpg",
      desktop: "06.jpg",
    },
    {
      mobile: "07.jpg",
      desktop: "07.jpg",
    },
    {
      mobile: "08.jpg",
      desktop: "08.jpg",
    },
    {
      mobile: "09.jpg",
      desktop: "09.jpg",
    },
    {
      mobile: "10.jpg",
      desktop: "10.jpg",
    },
    {
      mobile: "11.jpg",
      desktop: "11.jpg",
    },
    {
      mobile: "12.jpg",
      desktop: "12.jpg",
    },
    {
      mobile: "13.jpg",
      desktop: "13.jpg",
    },
    {
      mobile: "14.jpg",
      desktop: "14.jpg",
    },
  ]; */

  


  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const openImagePopup = (index) => {
    setSelectedImageIndex(index);
  };
  const closeImagePopup = () => {
    setSelectedImageIndex(null);
  };
  useEffect(() => {
    const body = document.body;
    // const html = document.documentElement; // Selecting the html element
  
    if (selectedImageIndex !== null) {  // Ensure 0 is treated as a valid index
      body.classList.add("overflow-hidden");
      // html.classList.add("overflow-hidden");
    } else {
      body.classList.remove("overflow-hidden");
      // html.classList.remove("overflow-hidden");
    }
  
    // Cleanup to remove class when the component unmounts
    return () => {
      body.classList.remove("overflow-hidden");
      // html.classList.remove("overflow-hidden");
    };
  }, [selectedImageIndex]);

  


  const showPreviousImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? data.dubaiimages.length - 1 : prevIndex - 1
    );
  };
  const showNextImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === data.dubaiimages.length - 1 ? 0 : prevIndex + 1
    );
  };

  /* const videoRef = useRef(null);

  const handlePlayVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }; */


  const [isOpen, setIsOpen] = useState(false);
  const videoRef = useRef(null); // Use a ref to access the video element

  // Function to open the modal
  const openModal = () => {
    setIsOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    if (videoRef.current) {
      videoRef.current.pause(); // Pause the video when the modal closes
      videoRef.current.currentTime = 0; // Optionally reset the video to the beginning
    }
    setIsOpen(false);
  };

  // useEffect to handle playing the video when the modal opens
  useEffect(() => {
    if (isOpen && videoRef.current) {
      videoRef.current.play(); // Play the video when the modal opens
    }
  }, [isOpen]); // Dependency on isOpen to trigger effect when modal state changes


  const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;


  return (
    <>
      <Layout title="Store | Chaashni Couture">
        <div className="site-content-wrap static-page storegallery-page-wrap">
          <div className="container storegallery-top-fluid">
            <div className="row">
              {/* <div className="col-md-4">
              <video
                  onClick={handlePlayVideo}
                  ref={videoRef}
                  width="1024"
                  height="1920"
                  controls
                  autoPlay
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster="/images/showroom/poster-img.jpg"
                >
                  <source
                    src="/images/showroom/walkthrough.mp4"
                    type="video/mp4"
                  />
                </video>
              </div> */}
              <div className="col-md-12">
                <p>Driven by a deep passion for fashion and an unshakable vision, Honey Tharwani brought Chaashni to the heart of Dubai.</p>
                <p>The store was born out of a simple but powerful idea — to fill a long-standing void for Indian women in Dubai who craved premium, stylish, and custom Indian wear that matched their taste and aspirations.</p>
                <p>With this new destination, Chaashni promises to bring the very best of Indian couture to Dubai — curated with love, crafted to perfection, and delivered with warmth.</p>
                <p>Shop No. 3, Equiti Arcade, Al Furjan West, <br/> Opposite Glamz by Danube<br/> Dubai</p>
                <div className="location-div"><Link to="https://maps.app.goo.gl/VJmoaGHtN6aCHJEq7?g_st=aw" target="_blank"><img src="/images/location.png" alt="Location" /> View on Google Maps</Link> <span> | </span> <a href="tel:+971503848387"><img src="/images/phone-icon.png" alt="" />+971503848387</a></div>
                
                {/* <div className="video-btn-box">
                  <span className="btn-span" onClick={openModal}>Watch Video</span>
                </div> */}
                {/* <p style={{textAlign: 'center'}}>Here’s a look inside the <strong>Chaashni Headquarters</strong> and <strong>Experience Center</strong>.</p> */}
              </div>
            </div>
          </div>

{data?.dubaivideos && (
          <div className="container video-top-fluid">
            <div className="row justify-content-center"> 
              {data.dubaivideos.map((src, index) => (            
              <div className="col-md-4" key={index}>
                <video
                  controls                 
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster={`${process.env.REACT_APP_IMAGE_URL}home/showroom/dubai/${src.poster}`}>
                  <source src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/dubai/${src.video}`} type="video/mp4" />
                </video>
                {/* <span>Behind the Seams</span> */}
              </div>))};                          
            </div>
          </div>
)}


          <div className="container-fluid storegallery-fluid">
          {data?.dubaiimages && (
            <div className="row">
              {data.dubaiimages.map((src, index) => (
                <div className="col-md-6 storegallery-box" key={index}>
                  <div className="storegallery">
                    <picture>
                      <source media="(min-width:650px)" srcSet={`${process.env.REACT_APP_IMAGE_URL}home/showroom/dubai/desktop/${src.desktop}`} />
                      <img 
                        src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/dubai/mobile/${src.mobile}`}
                        alt={`Thumbnail ${index + 1}`}
                        className="gallery-image" onClick={() => openImagePopup(index)}
                      />
                    </picture>
                  </div>
                </div>
              ))}
            </div> )}
          </div>
        </div>
      </Layout>
      {selectedImageIndex !== null && (
        <div className="image-popup">
          <div className="image-popup-overlay" onClick={closeImagePopup}></div>
          <span className="close" onClick={closeImagePopup}></span>
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/dubai/mobile/${data.dubaiimages[selectedImageIndex].desktop}`}
            alt={`Image ${selectedImageIndex + 1}`}
            className="popup-image"
          />
          <button className="prev" onClick={showPreviousImage}></button>
          <button className="next" onClick={showNextImage}></button>
        </div>
      )}


      {isOpen && (
        <div className="video-modal">
          <div className="video-overlay" onClick={closeModal}> <span className="close"></span></div>
          <div className="video-modal-content">
          <span className="close mobile-video-close" onClick={closeModal}></span>
            {/* Video element with ref */}
            <video ref={videoRef} controls  width="1024"
                  height="1920"
                  autoPlay
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster={`${process.env.REACT_APP_IMAGE_URL}home/showroom/poster-img.jpg`}>
                  <source src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/walkthrough.mp4`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </>
  );
};

export default StoreGalleryDubai;
